import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { verifyEmail } from "../../services/authService";
import { setToken } from "../../services/userService";
import { isProfileComplete } from "../../utils/profile";
import "../welcome/welcome.scss";

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = useMemo(() => searchParams.get("token") || "", [searchParams]);
  const navigate = useNavigate();
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(Boolean(token));

  useEffect(() => {
    if (!token) {
      setError("This verification link is missing a token.");
      setLoading(false);
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const result = await verifyEmail(token);
        if (cancelled) {
          return;
        }
        if (result?.token && result?.user) {
          localStorage.setItem("token", result.token);
          localStorage.setItem("immerselyEmail", result.user.email || "");
          localStorage.setItem("userRole", result.user.role || "playtester");
          setToken(result.token);
          const role = (result.user.role || "playtester").toLowerCase();
          if (role === "developer") {
            navigate(isProfileComplete(result.user) ? "/developer" : "/developer/welcome?profile_completed=false");
          } else {
            navigate(isProfileComplete(result.user) ? "/dashboard" : "/welcome?profile_completed=false");
          }
          return;
        }
        setStatus(result.message || "Email verified. You can sign in now.");
      } catch (err) {
        if (!cancelled) {
          setError(err.response?.data?.message || "This verification link is invalid or has expired.");
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [token, navigate]);

  return (
    <div className="modern-welcome-container">
      <div className="background-elements">
        <div className="bg-element bg-element-1"></div>
        <div className="bg-element bg-element-2"></div>
        <div className="bg-element bg-element-3"></div>
      </div>
      <div className="main-content">
        <div className="content-wrapper">
          <div className="welcome-card">
            <div className="card-background"></div>
            <div className="card-header">
              <h1 className="card-title">Verify your email</h1>
              <p className="card-subtitle">
                {loading ? "Confirming your email..." : "Use the link we sent to finish creating your account."}
              </p>
            </div>
            <div className="card-content">
              {error && (
                <p style={{ color: "#fca5a5", fontSize: "0.875rem", marginBottom: "1rem", textAlign: "center" }}>
                  {error}
                </p>
              )}
              {status && (
                <p style={{ color: "#86efac", fontSize: "0.875rem", marginBottom: "1rem", textAlign: "center" }}>
                  {status}
                </p>
              )}
              <div style={{ textAlign: "center" }}>
                <Link to="/" style={{ color: "#e879f9", textDecoration: "none", fontSize: "0.875rem", marginRight: "1rem" }}>
                  Playtester sign in
                </Link>
                <Link to="/developer/signin" style={{ color: "#e879f9", textDecoration: "none", fontSize: "0.875rem" }}>
                  Developer sign in
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerifyEmail;
